// Generated by ts-to-zod
import { z } from "zod";

export const extensionsSchema = z.object({
  color: z.string().optional().nullable(),
  displayDecimals: z.number().optional().nullable(),
});

export const masterExtensionsSchema = z.object({
  color: z.string().optional().nullable(),
  displayDecimals: z.number().optional().nullable(),
  price: z.number().optional().nullable(),
});

export const masterTokenSchema = z.object({
  chainId: z.number(),
  address: z.string(),
  decimals: z.number(),
  name: z.string(),
  symbol: z.string(),
  logoURI: z.string(),
  tags: z.array(z.string()).optional().nullable(),
  extensions: masterExtensionsSchema.optional().nullable(),
});

export const metadataSchema = z.object({
  total: z.number(),
  lastUpdated: z.string(),
});

export const pricedTokenSchema = z.object({
  chain_id: z.number(),
  price: z.number().nullable(),
  market_cap: z.number(),
  vol_24hr: z.number(),
  change_24hr: z.number(),
  last_updated: z.string(),
});

export const pricesResponseSchema = z.object({
  prices: z.record(pricedTokenSchema),
  metadata: metadataSchema,
});

// TODO: Awaiting backend explict typing for get_prices_by_chain
// https://bebopdex.slack.com/archives/C03LGEVBQ2W/p1697513994051759
export const pricesByChainResponseSchema = z.record(z.number());

export const tagSchema = z.object({
  name: z.string(),
  description: z.string(),
});

export const tokenInfoResponseSchema = z.object({
  p: z.number().nullable(),
  m: z.number().nullable(),
  v: z.number().nullable(),
  c: z.number().nullable(),
  u: z.string(),
});

export const tokenListTokenSchema = z.object({
  chainId: z.number(),
  address: z.string(),
  decimals: z.number(),
  name: z.string(),
  symbol: z.string(),
  logoURI: z.string(),
  tags: z.array(z.string()).optional().nullable(),
  extensions: extensionsSchema.optional().nullable(),
});

export const tokenMetadataSchema = z.object({
  name: z.string(),
  symbol: z.string(),
  decimals: z.number(),
});

export const validationErrorSchema = z.object({
  loc: z.array(z.union([z.string(), z.number()])),
  msg: z.string(),
  type: z.string(),
});

export const versionSchema = z.object({
  major: z.number(),
  minor: z.number(),
  patch: z.number(),
});

export const hTTPValidationErrorSchema = z.object({
  detail: z.array(validationErrorSchema).optional(),
});

export const masterTokenListSchema = z.object({
  keywords: z.array(z.string()),
  logoURI: z.string(),
  name: z.string(),
  tags: z.record(tagSchema).optional().nullable(),
  timestamp: z.string(),
  tokens: z.array(masterTokenSchema),
  version: versionSchema,
});

export const tokenListSchema = z.object({
  keywords: z.array(z.string()),
  logoURI: z.string(),
  name: z.string(),
  tags: z.record(tagSchema).optional().nullable(),
  timestamp: z.string(),
  tokens: z.array(tokenListTokenSchema),
  version: versionSchema,
});
